import { compose } from 'lodash/fp';
import AdminLink from '../../../../../types/AdminLink';
import api from '../../../../api';
import { SETTINGS } from '../../../../routes';
import Breadcrumbs from '../../../components/Breadcrumbs';
import PageHeader from '../../../components/PageHeader';
import PageTitle from '../../../components/PageTitle';
import { AppContext, withAppContext } from '../../../hoc/withAppContext';
import { withPageData } from '../../../hoc/withPageData';
import AdminOverview from '../../Admin/Overview/presenter';
import { countAdminErrors, groupLinksByCategory } from '../../Admin/Overview/service';

function AutomaticUserImportPage({ adminLinks, appContext }: { adminLinks: AdminLink[]; appContext: AppContext }) {
    const title = 'Automatic User Import';
    const path = [{ label: 'Settings', url: SETTINGS, prependBaseUrl: true }, { label: 'Automatic User Import' }];
    return (
        <>
            <PageTitle title={title} />
            <Breadcrumbs path={path} />
            <PageHeader title={title}></PageHeader>
            <AdminOverview
                categories={groupLinksByCategory(adminLinks)}
                errorCount={countAdminErrors(adminLinks)}
                currentUser={appContext.user}
            />
        </>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () => api.admin.getAutomaticUserImportLinks(),
        },
    }),
    withAppContext
)(AutomaticUserImportPage);
